export function buildImageUrl(path?: string): string {
  if (!path || !path.trim()) {
    return "/img/logo/LogoLinkServs.png";
  }

  const clean = path.trim();

  // URL absoluta: S3, CloudFront, etc.
  if (/^https?:\/\//i.test(clean)) {
    return clean;
  }

  // Ruta relativa antigua del backend
  return `${import.meta.env.VITE_ASSETS_URL}/${clean.replace(/^\/+/, "")}`;
}

export function buildDocumentUrl(path?: string): string {
  if (!path) return "";

  const clean = path.trim();

  if (/^https?:\/\//i.test(clean)) {
    return clean;
  }

  return `${import.meta.env.VITE_ASSETS_URL}/${clean.replace(/^\/+/, "")}`;
}